import { CopyBlock } from "shared/UI/CopyBlock/CopyBlock";
import { ReactComponent as DownChevron } from "shared/assets/Icons/down.svg";
import { ModuleInfo } from "../../interfaces";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import classNames from "classnames";
import { useState } from "react";

export const ModuleInfoAccordion = (info: ModuleInfo) => {
  const [openAccordion, setOpenAccordion] = useState(false);
  const { title, description, steps, stepBannerInsert, endNote } = info;
  const handleClickAccordion = () => {
    setOpenAccordion(!openAccordion);
  };

  return (
    <div data-testid="account-security-module-info" className="w-full px-5 py-5 mt-5 text-white rounded-b-lg shadow-md bg-navy-blue md:px-10">
      <button className="flex items-center justify-between w-full space-x-2" onClick={handleClickAccordion}>
        <h3 className="text-left -mb-2">
          <span className="text-white">{title}</span>
        </h3>
        <div
          className={classNames("duration-200 w-5 h-5 md:w-10 md:h-10", {
            "rotate-180": openAccordion,
          })}
        >
          <DownChevron style={{ width: "inherit", height: "inherit" }} />
        </div>
      </button>
      {openAccordion && (
        <div data-testid="info-accordion-body" className="mt-5 space-y-6 ">
          <p>{description}</p>
          {steps && steps.map((step, index) => <CopyBlock key={index} content={step} />)}
          {stepBannerInsert && (
            <RoundedCard>
              <CopyBlock content={stepBannerInsert} className="text-navy-blue" />
            </RoundedCard>
          )}
          {endNote && <CopyBlock content={endNote} />}
        </div>
      )}
    </div>
  );
};
